import { Route, Switch, Redirect } from "react-router-dom";

import LoginPage from "./Login";
import RegisterParticipantePage from "./RegisterParticipante";
import RecoverPage from "./Recover";
import ResetPage from "./Reset";
import SelecionarCondominio from "./SelecionarCondominio";
import FirebaseActions from "./FirebaseActions";
import { useCurrentAuth } from "core/features/auth/auth.store";
import { useCurrentTenant } from "core/features/auth/tenant.store";

function Auth() {
  const { isLogged } = useCurrentAuth();
  const { tenant } = useCurrentTenant();

  if (isLogged && tenant.id) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <Switch>
      <Route
        path="/auth/selecionar-empresa"
        exact
        component={SelecionarCondominio}
      />
      <Route path="/auth/login" component={LoginPage} />
      <Route path="/auth/register-participante" component={RegisterParticipantePage} />
      <Route path="/auth/recover" component={RecoverPage} />
      <Route path="/auth/reset" component={ResetPage} />
      <Route path="/auth/firebase-actions" component={FirebaseActions} />
    </Switch>
  );
}

export default Auth;
